module.exports = __webpack_public_path__ + "img/welcome-banner@2x.851b4fcb.png";